var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "m5 11 7-7 7 7v9h-5v-5h-4v5H5v-9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "m21.71 12.29-9-9a1 1 0 0 0-1.41 0l-9 9c-.39.39-.39 1 0 1.41s1 .39 1.41 0l.29-.29V20a1 1 0 0 0 1 1h5v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5h5a1 1 0 0 0 1-1v-6.59l.29.29c.39.39 1 .39 1.41 0s.39-1 0-1.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.71 12.29-9-9a1 1 0 0 0-1.41 0l-9 9c-.39.39-.39 1 0 1.41s1 .39 1.41 0l.29-.29V20a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6.59l.29.29c.39.39 1 .39 1.41 0s.39-1 0-1.41ZM11 19v-3h2v3h-2Zm7 0h-3v-3a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v3H6v-7.59l6-6 6 6V19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.8060128ff22a30389bbe7da8234dcd61.svg";
export { ForwardRef as ReactComponent };